import { Location } from "history";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NavLink, match } from "react-router-dom";
import { ReactComponent as DashboardSVG } from "go-core/images/svg/navigation/dashboard.svg";
import { ReactComponent as SaleSVG } from "go-core/images/svg/navigation/reports.svg";
import { ReactComponent as SettingsSVG } from "go-core/images/svg/navigation/settings.svg";
import { OrganizationState } from "../../../services/organizations/types";
import { hasRole, selectIsAdmin } from "../../../services/users/selectors";

interface NavigationProps {
	organization: OrganizationState;
}

const NavigationOrganizationMenu = (props: NavigationProps) => {
	const organization = props.organization;
	const isAdmin = useSelector(selectIsAdmin);
	const hasOfficeRole = useSelector(hasRole("OFFICE"));
	const { t } = useTranslation();

	return (
		<Nav variant="pills" className="flex-column" defaultActiveKey="/home">
			<Nav.Item>
				<Nav.Link
					as={NavLink}
					to={`/${organization.id}`}
					isActive={(match: match | null, location: Location) => {
						return match?.url === location.pathname;
					}}
				>
					<div className="nav-link-svg">
						<DashboardSVG />
					</div>
					<span>Dashboard</span>
				</Nav.Link>
			</Nav.Item>
			<Nav.Item>
				<Nav.Link as={NavLink} to={`/${organization.id}/subscriptions`}>
					<div className="nav-link-svg">
						<SaleSVG />
					</div>
					<span>{t("common.word.subscriptions")}</span>
				</Nav.Link>
			</Nav.Item>
			{(organization.permissions.includes("DEFAULT") || isAdmin || hasOfficeRole) && (
				<Nav.Item>
					<Nav.Link as={NavLink} to={`/${organization.id}/loans`}>
						<div className="nav-link-svg">
							<SaleSVG />
						</div>
						<span>{t("common.word.loans")}</span>
					</Nav.Link>
				</Nav.Item>
			)}
			{(organization.permissions.includes("USERS_MANAGMENT") || isAdmin || hasOfficeRole) && (
				<Nav.Item>
					<Nav.Link as={NavLink} to={`/${organization.id}/users`}>
						<div className="nav-link-svg">
							<SaleSVG />
						</div>
						<span>{t("common.word.users", { ns: "lib" })}</span>
					</Nav.Link>
				</Nav.Item>
			)}
			{(organization.permissions.includes("DEFAULT") || isAdmin) && (
				<Nav.Item>
					<Nav.Link as={NavLink} to={`/${organization.id}/settings`}>
						<div className="nav-link-svg">
							<SettingsSVG />
						</div>
						<span>{t("common.word.settings", { ns: "lib" })}</span>
					</Nav.Link>
				</Nav.Item>
			)}
		</Nav>
	);
};

export default NavigationOrganizationMenu;
